// extracted by mini-css-extract-plugin
export default {"container":"filter-chip__container___2gfPt","close-icon":"filter-chip__close-icon___3YJBX"};